export type LockerPositionType = {
  id: number;
  code: string;
  name: string;
};
export enum LockerColumnTypes {
  LARGE = 'Large',
  MEDIUM = 'Medium',
  SMALL = 'Small',
  SCREEN = 'Screen',
}
